import { render, staticRenderFns } from "./skeletonBox.vue?vue&type=template&id=08d3a3b6&scoped=true&"
import script from "./skeletonBox.vue?vue&type=script&lang=js&"
export * from "./skeletonBox.vue?vue&type=script&lang=js&"
import style0 from "./skeletonBox.vue?vue&type=style&index=0&id=08d3a3b6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d3a3b6",
  null
  
)

export default component.exports